export class AlertNotification {
  message: string;
  type: string;
  template: string;
}
